import React, { forwardRef, useContext } from 'react';
import DiscoveryContext from '../../../contexts/discoveryContext/context';

const WithTracking = (source) => (ChildComponent) =>
  forwardRef(({ injected, ...props }, ref) => {
    const {
      tracking: {
        trackButtonClick,
        trackInputEntered,
        trackMapMoved,
        trackPanelOpen,
        trackPanelClose,
        trackGenericEvent,
      },
    } = useContext(DiscoveryContext);

    return (
      <ChildComponent
        injected={{
          ...injected,
          tracking: {
            trackButtonClick: trackButtonClick
              ? trackButtonClick(source)
              : () => {},
            trackInputEntered: trackInputEntered
              ? trackInputEntered(source)
              : () => {},
            trackMapMoved: trackMapMoved ? trackMapMoved(source) : () => {},
            trackPanelOpen: trackPanelOpen ? trackPanelOpen(source) : () => {},
            trackPanelClose: trackPanelClose
              ? trackPanelClose(source)
              : () => {},
            trackGenericEvent: trackGenericEvent
              ? trackGenericEvent(source)
              : () => {},
          },
        }}
        ref={ref}
        {...props}
      />
    );
  });

export default WithTracking;
